import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { locationChange } from '@savgroup-front-common/core/domains/router/actionCreators';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import { useIsBTobEnabled } from '../hooks/useIsBTobEnabled';

import ClassiqueLayout from './ClassiqueLayout';
import useLoadOrder from './hooks/useLoadOrder';
import InitProvider from './InitProvider/InitProvider.context';
import { useLayout } from './NewLayout.hooks';
import ProfessionalLayout from './ProfessionalLayout';

export default function NewLayout() {
  const location = useLocation();
  const dispatch = useDispatch();

  const { sellerId, ownerId, login, enableServicePortal } = useLayout();
  const isBtoBPortalEnabled = useIsBTobEnabled();
  const { orders, openedFiles, closedFiles, isLoading } = useLoadOrder({
    ownerId,
  });

  useEffect(() => {
    dispatch(
      locationChange({
        location,
      } as any),
    );
  }, [dispatch, location]);

  if (!sellerId || isLoading || !ownerId) {
    return <BaseLoader />;
  }

  if (isBtoBPortalEnabled) {
    return (
      <InitProvider
        ownerId={ownerId}
        login={login}
        orders={orders}
        openedFiles={openedFiles}
        closedFiles={closedFiles}
        enableServicePortal={enableServicePortal}
      >
        <ProfessionalLayout sellerId={sellerId} />
      </InitProvider>
    );
  }

  return (
    <InitProvider
      ownerId={ownerId}
      login={login}
      orders={orders}
      openedFiles={openedFiles}
      closedFiles={closedFiles}
      enableServicePortal={enableServicePortal}
    >
      <ClassiqueLayout sellerId={sellerId} />
    </InitProvider>
  );
}
